import {
    Box,
    Button, CircularProgress, Stack,
    Tab,
    Tabs, Typography
} from "@mui/material";
import React, { SyntheticEvent, useEffect, useState } from "react";
import {
    useGetAllQuery,
    useGetUrlQuery,
    useGetPendingOwnershipTransfersQuery,
} from "../../../api/userApiSlice";
import LassoGrid from "../../../components/LassoGrid";
import { UserGridTableDef } from "../TableDefinitionsGridUser";
import LassoModal from "../../../components/LassoModal";
import UserActionConfirm from "./UserActionConfirm";
import { CellKeyDownEvent } from '@ag-grid-community/core';


const UserAccountsLayout = () => {
    const [tab, setTab] = useState('pendingUser');
    const { data: usersData, isFetching } = useGetAllQuery({});
    const { data: pendingOwnershipTransfer } = useGetPendingOwnershipTransfersQuery({});
    const data = { ...usersData, pendingOwnershipTransfer: pendingOwnershipTransfer || [] };
    const [email, setEmail] = useState("")
    const [ducType, setDucType] = useState("")
    const [open, setOpen] = useState(false)
    const [openRevoke, setOpenRevoke] = useState(false)
    const [username, setUsername] = useState("")
    const [skip, setSkip] = useState(true)
    const [loading, setLoading] = useState(false)
    const { data: url, refetch } = useGetUrlQuery({ email: email, ducType: ducType }, { skip: skip })

    const changeTab = (event: SyntheticEvent, newValue: string) => {
        setTab(newValue);
    }

    const handleGetLink = (event: any) => {

        if(event.colDef.field === "signingUrl" && event?.data?.signingUrl === "Pending NIDA approval"){
            setOpen(true)
            setLoading(true)
            setEmail(event?.data?.email)
            // Pass the row's DUC category (GENERAL/AIAN) so the backend resolves the signing URL
            // for THIS document. Without it, a PI with both an AIAN and a General DUC in progress
            // could be handed the wrong envelope's signing view.
            setDucType(event?.data?.ducType ?? "")
            setSkip(false)
            refetch()

        }
        // revoke user DUC
        if(event?.colDef?.colId === 'revokeDuc' && event?.data?.ducStatus !== 'NotSubmitted') {
            setOpenRevoke(true)
            setUsername(event?.data?.username)
            setEmail(event?.data?.email)
        }
    }

    useEffect(() => {
        if(url?.url){
            setLoading(false)
        }
    }, [url]);

    if (isFetching) {
        return <div>loading</div>
    }

    const handleClickBack = () => {
        setOpen(false);
    }

    const handleClickSign = () => {
        setOpen(false)
        window.open(url?.url, "_self")
    }

    const handleRevokeKeyDown = (e: CellKeyDownEvent) => {
        //@ts-ignore
        const pressedEnter = e.event?.key === "Enter" //"key" is not in the type definition for some reason.
        if(pressedEnter) {
            handleGetLink(e);
        }
    }



    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: 2,
                    overflowX: 'auto',
                    minWidth: '0'
                }}
            >
                <Tabs
                    data-testid="admin-dashboard-duc-tabs-user-status"
                    value={tab}
                    onChange={changeTab}
                    sx={{ minWidth: 'max-content' }}
                >
                    <Tab value="pendingUser" label={`Pending (USER) (${data?.pendingUser?.length ?? 0})`}/>
                    <Tab value="pendingIso" label={`Pending (ISO) (${data?.pendingIso?.length ?? 0})`}/>
                    {/* TODO: Change pendingNida keys to pendingDAC*/}
                    <Tab value="pendingNida" label={`Pending (DAC) (${data?.pendingNida?.length ?? 0})`}/>
                    <Tab value="pendingTraining" label={`Pending Training (${data?.pendingTraining?.length ?? 0})`}/>
                    <Tab value="pendingOwnershipTransfer" label={`Pending (Change Lead Investigator) (${data?.pendingOwnershipTransfer?.length ?? 0})`}/>
                    <Tab value="active" label={`Active (${data?.active?.length ?? 0})`}/>
                    <Tab value="inactive" label={`Expired Access (${data?.inactive?.length ?? 0})`}/>
                    <Tab value="rejected" label={`DAC Rejected (${data?.rejected?.length ?? 0})`}/>
                    <Tab value="allUsers" label={`All Users (${data?.allUsers?.length ?? 0})`}/>
                </Tabs>
            </Box>
            <Box
                sx={{
                    flexGrow: 1,
                    height: 'calc(100% - 64px)'
                }}
            >
                <LassoGrid
                    columns={UserGridTableDef?.[tab]?.columns || []}
                    data={data?.[tab] || []}
                    idKey={'id'}
                    searchable={true}
                    moreInfo={UserGridTableDef?.[tab]?.moreInfo || []}
                    actions={UserGridTableDef?.[tab]?.rowActions ?? undefined}
                    page={"users"}
                    tab={tab}
                    focusSuppressCell={false}
                    showHide={UserGridTableDef?.[tab]?.showHide}
                    onCellClicked= {(event: any) => handleGetLink(event)}
                    onCellKeyDown={handleRevokeKeyDown}
                />

                <LassoModal open={open}>

                    {loading && <CircularProgress sx={{ width: "250px", height: "250px" }} />}

                    {!loading &&
                        <Stack flexDirection="column">
                            <Typography>
                                Would you like to review and sign the document?
                            </Typography>
                            <Stack flexDirection="row" justifyContent="space-evenly">
                                <Button variant="primary" onClick={handleClickSign}>
                                    Yes
                                </Button>
                                <Button variant="tertiary" onClick={handleClickBack}>
                                    Back
                                </Button>
                            </Stack>
                        </Stack>}
                </LassoModal>

                <UserActionConfirm open={openRevoke} setOpen={setOpenRevoke} username={username} email={email} ></UserActionConfirm>

            </Box>
        </Box>
    )
}

export default UserAccountsLayout;